import { render, staticRenderFns } from "./LButton.vue?vue&type=template&id=090eaf04"
import script from "./LButton.vue?vue&type=script&lang=js"
export * from "./LButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports